import { Breakpoints } from '@doordash/design-language';
import styled from 'styled-components';

var ErrorIconWrapper = styled.div.withConfig({
  displayName: "ErrorMessage__ErrorIconWrapper",
  componentId: "sc-1trx7uu-0"
})(["display:flex;align-items:center;justify-content:center;height:", "px;width:", "px;@media (min-width:", "px){height:", "px;width:", "px;}"], function (props) {
  return props.containerHeight;
}, function (props) {
  return props.containerHeight;
}, Breakpoints.Mobile + 1, function (props) {
  return props.desktopContainerHeight;
}, function (props) {
  return props.desktopContainerHeight;
});

export { ErrorIconWrapper };
